import React from "react";
import MemoryCard from "./MemoryCard";

export default function GameBoard({ cards, onCardClick }) {

  return ( // The game board displays all the memory cards in a grid layout
    <div className="game-board">

      {cards.map((card, index) => (
        <MemoryCard
          key={card.id}
          card={card}
          onClick={() => onCardClick(index)}
        />
      ))}

    </div>
  );

}